import {
  collection,
  query,
  where,
  getDocs,
  UpdateData,
} from "firebase/firestore";
import { db } from "../../firebase/firebase";
import { snapshotToArray } from "../../utils/fbUtil";
import { BaseApi, BaseRecord, getErrorMessage } from "./BaseApi";
export const USER_FIELDS = [
  { key: "name", alias: "Tên" },
  { key: "email", alias: "Tài khoản" },
  { key: "phapDanh", alias: "Pháp danh" },
  { key: "birth", alias: "Ngày sinh" },
  { key: "gender", alias: "Giới tính" },
  { key: "address", alias: "Địa chỉ" },
  { key: "quyy", alias: "Đã quy y tại" },
  { key: "tp", alias: "Thành phần" },
  { key: "zalo", alias: "Zalo" },
  { key: "phone", alias: "Số điện thoại" },
  { key: "fb", alias: "Link Facebook" },
  { key: "tenFb", alias: "Tên Facebook" },
  { key: "gmail", alias: "Gmail" },
  { key: "address2", alias: "Địa chỉ 2" },
  { key: "ngayVaoDaoTrang", alias: "Ngày vào ĐT" },
  { key: "ngayLenGieoDuyen", alias: "Ngày lên Gieo Duyên" },
  { key: "ngayLenTuyHy", alias: "Ngày lên Tùy Hỷ" },
  { key: "ngayLenDuThinh", alias: "Ngày lên Dự Thính" },
  { key: "ngayLenChinhThuc", alias: "Ngày lên Chính Thức" },
  { key: "ngheNghiep", alias: "Nghề nghiệp" },
  { key: "kyNang", alias: "Kỹ năng" },
  { key: "cachDTT", alias: "Cách ĐTT" },
  { key: "bach7", alias: "Bài PNBDTLH" }, // 0:chưa|1:đang|2:bạch xong
  { key: "bach49", alias: "Bài 49" }, // 0:chưa|1:đang|2:bạch xong
  { key: "bach108", alias: "Bài 108" }, // 0:chưa|1:đang|2:bạch xong
  { key: "nguoiHuongDan", alias: "Người hướng dẫn" },
];

const MAX_PAD_NUM = 999;
class UserApi extends BaseApi<any> {
  constructor() {
    const defaultEntity = {
      name: "",
      email: "",
      daoTrang: "",
      daotrangcu: [],
      admin: false,
      birth: "",
      phone: "",
      zalo: "",
      facebook: "",
      gmail: "",
      address: "", //dia chi NB
      address2: "", //dia chi VN
      ngayVaoDaoTrang: "",
      ngayLenGieoDuyen: "",
      ngayLenTuyHy: "",
      ngayLenDuThinh: "",
      ngayLenChinhThuc: "",
      phapDanh: "",
      thanhPhan: "", // A, B, C , D
      ngheNghiep: "",
      kyNang: "",
      tenFb: "",
      cachDTT: "",
      bach7: "", // 0:chưa|1:đang|2:bạch xong
      bach49: "",
      bach108:"",
      nguoiHuongDan: "",
    };
    super("users", defaultEntity);
  }

  async getAllMembers(daoTrangId: string) {
    return await this.query(where("daoTrang", "==", daoTrangId));
  }
  async getMembers(accounts: string[]) {
    return await this.query(where("email", "in", accounts));
  }
  async genAccount(name: string) {
    try {
      let account = shortenName(name);

      const ref = collection(db, this.collectionName);
      const q = query(
        ref,
        where("email", ">=", account),
        where("email", "<=", `${account}${MAX_PAD_NUM}`)
      );
      const querySnapshot = await getDocs(q);
      const users = snapshotToArray(querySnapshot);

      if (users.length > 0) {
        const lst = users.map((u) => u.email);
        for (let i = lst.length + 1; i > 0; i--) {
          if (!lst.includes(`${account}${i}`)) {
            account = `${account}${i}`;
            break;
          }
        }
      }

      return { result: { account, users } };
    } catch (ex: unknown) {
      return { error: getErrorMessage(ex) };
    }
  }
}


const userApi = new UserApi();

export const getAllMembers = (daoTrangId: string, token?: string) => {
  void token;
  return userApi.getAllMembers(daoTrangId);
};
export const getMembers = (accounts: string[], token?: string) => {
  void token;
  return userApi.getMembers(accounts);
};
export const getAllUsers = (_user: unknown, token?: string) => {
  void _user;
  void token;
  return userApi.getAll();
};
export const createUser = (user: Record<string, unknown>, token?: string) => {
  void token;
  return userApi.create(user);
};
export const updateUser = (
  id: string,
  changes: UpdateData<BaseRecord>,
  token?: string
) => {
  void token;
  return userApi.update(id, changes);
};
export const saveUser = (user: Record<string, unknown>, token?: string) => {
  void token;
  return userApi.save(user);
};
export const removeUser = (id: string, token?: string) => {
  void token;
  return userApi.remove(id);
};
export const saveOrCreateUser = (
  user: Record<string, unknown>,
  token?: string
) => {
  void token;
  return userApi.saveOrCreate(user);
};
export const genAccount = (name: string, token?: string) => {
  void token;
  return userApi.genAccount(name);
};
export const newDefaultUser = () => cloneObj(userApi.defaultEntity);

export const USER_THANH_PHAN = [
  {
    label: "Chính thức",
    value: "A",
  },
  {
    label: "Dự thính",
    value: "B",
  },
  {
    label: "Tùy hỷ",
    value: "C",
  },
  {
    label: "Gieo duyên",
    value: "D",
  },
  {
    label: "Tín chủ mới",
    value: "E",
  },
];

function shortenName(name: string): string {
  const arr = name
    .trim()
    .split(/\s+/)
    .filter((part) => part.length > 0);

  if (arr.length === 0) {
    return "";
  }

  let account = arr[arr.length - 1];
  for (let i = 0; i < arr.length - 1; i++) {
    account = account + (arr[i][0] ?? "");
  }
  return account.toLowerCase();
}

export function cloneObj<T>(u: T): T {
  return { ...u };
}
